module.exports = __webpack_public_path__ + "static/media/19ESCAP8.9e227461.jpg";